import React from 'react';

import { Container } from './styles';

const Breadcrumbs: React.FC = ({children}) => {
  return (
    <Container>
      {children}
    </Container>
  );
}

export default Breadcrumbs;
